export default __webpack_public_path__ + "static/media/about-3.db7cfaf6.jpg";